<template>
    <modal class="confirm" @close="close">
        <h3 slot="modal-header" class="mt-0">
            <slot name="modal-header"></slot>
        </h3>
        <div slot="modal-body">
            <slot name="modal-body"></slot>
        </div>
        <div slot="modal-footer">
            <CompassButton
                :label="$t.__('common.actions.cancel')"
                type="secondary"
                @click="close"
            />
            <CompassButton :label="$t.__('common.actions.confirm')" @click="confirm" />
        </div>
    </modal>
</template>

<script>
import Modal from 'vcomponents/utilities/Modal.vue';

export default {
    components: {
        Modal,
    },
    props: {
        relatedtype: {
            type: String,
            required: true,
        },

        relatedid: {
            type: Number,
            required: true,
        },
    },
    methods: {
        close() {
            this.$emit('close');
        },

        confirm() {
            this.$emit('confirm', this.$props);
            this.$emit('close');
        },
    },
};
</script>
